import { render, staticRenderFns } from "./Livekit.vue?vue&type=template&id=12fdc178&"
import script from "./Livekit.vue?vue&type=script&lang=js&"
export * from "./Livekit.vue?vue&type=script&lang=js&"
import style0 from "./Livekit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports